export { actionPresentation } from './action-layout';
export const ACTION_PRESENTATION_FINISHED = 'poneva:action-presentation-finished';
export const ACTION_TURN_CHANGED = 'poneva:action-turn-changed';
const activeThreads = new Set<string>();
export function actionTurnRunning(threadId: string) {
  return activeThreads.has(threadId);
}
export function setActionTurnRunning(threadId: string, running: boolean) {
  if (running) activeThreads.add(threadId);
  else activeThreads.delete(threadId);
  window.dispatchEvent(
    new window.CustomEvent(ACTION_TURN_CHANGED, { detail: { threadId, running } }),
  );
  if (!running) notifyActionPresentationFinished(threadId);
}
export function notifyActionPresentationFinished(threadId?: string) {
  if (typeof window !== 'undefined')
    window.dispatchEvent(
      new window.CustomEvent(ACTION_PRESENTATION_FINISHED, { detail: { threadId } }),
    );
}
